import React from "react";

const PinIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5Z" />
  </svg>
);

const PeopleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3Zm-8 0a3 3 0 1 0-3-3 3 3 0 0 0 3 3Zm0 2c-2.7 0-8 1.3-8 4v2h16v-2c0-2.7-5.3-4-8-4Zm8 0c-.3 0-.7 0-1.1.1 1.3.9 2.1 2 2.1 3.9v2h6v-2c0-2.7-5.3-4-7-4Z" />
  </svg>
);

const MyCircleList = ({ usersCircles, companyIdToParam }) => (
  <div className="container col-md-8 col-lg-6">
    <ul className="mp-circle-card">
      {usersCircles.map((usersCircle, index) => {
        const role = usersCircle.is_owner
          ? "オーナー"
          : usersCircle.manager_status
          ? "クリエイター"
          : null;
        const href = companyIdToParam
          ? `/community/${companyIdToParam}/circle/${usersCircle.circle.id}`
          : `/circle/${usersCircle.circle.id}`;
        return (
          <li key={index} className="mp-circle-item">
            <a className="mp-circle-link" href={href}>
              <img
                className="mp-circle-thumb"
                src={usersCircle.circle.main_image_url}
                alt=""
                onError={(e) => {
                  e.target.src = "/images/ja2/img_noimage.gif";
                }}
              />
              <div className="mp-circle-body">
                <div className="mp-circle-head">
                  <h6 className="mp-circle-name">{usersCircle.circle.name}</h6>
                  {role && <span className="mp-role">{role}</span>}
                </div>
                <div className="mp-circle-meta">
                  {usersCircle.circle.pref && (
                    <span>
                      <PinIcon />
                      {usersCircle.circle.pref}
                    </span>
                  )}
                  <span>
                    <PeopleIcon />
                    {usersCircle.circle.real_num_of_members}
                  </span>
                </div>
              </div>
            </a>
          </li>
        );
      })}
    </ul>
  </div>
);

export default MyCircleList;
